import { render, staticRenderFns } from "./WebItem.vue?vue&type=template&id=f21ca250&scoped=true"
import script from "./WebItem.vue?vue&type=script&lang=js"
export * from "./WebItem.vue?vue&type=script&lang=js"
import style0 from "./WebItem.vue?vue&type=style&index=0&id=f21ca250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21ca250",
  null
  
)

export default component.exports